module.exports = __webpack_public_path__ + "static/rivellalogo-91fd137904ee8fac01f2a7b24b04c34f.png";